import React from 'react';
import { Card } from 'react-native-paper';
// Common components
import { LabeledField } from '../components/LabeledField';
import { TEXT_FIELD_WIDTH } from '../components/consts';
import { FormCard } from './FormCard';
import { getLabel, DescLabels } from './formValuesModel';
export const SourceCard = ({ readOnly }) => {
    return (<FormCard>
      <Card.Content>
        <LabeledField required name="sourceDesc" label={getLabel('sourceDesc', DescLabels) || ''} width={TEXT_FIELD_WIDTH} readOnly={readOnly}/>
      </Card.Content>
    </FormCard>);
};
